import React from "react";

/**
 * LoadingSkeleton Component
 * Animated loading placeholder for better UX
 */
const LoadingSkeleton = ({ variant = "card", count = 1, className = "" }) => {
  const skeletons = Array.from({ length: count }, (_, i) => i);

  const variants = {
    card: (
      <div className="rounded-xl bg-slate-200 dark:bg-slate-700 p-4 animate-pulse">
        <div className="h-32 bg-slate-300 dark:bg-slate-600 rounded-lg mb-3" />
        <div className="h-4 bg-slate-300 dark:bg-slate-600 rounded w-3/4 mb-2" />
        <div className="h-3 bg-slate-300 dark:bg-slate-600 rounded w-1/2" />
      </div>
    ),
    table: (
      <div className="rounded-2xl border-2 border-slate-200 dark:border-slate-700 bg-slate-100 dark:bg-slate-800 h-32 animate-pulse flex flex-col items-center justify-center gap-2">
        <div className="h-8 w-16 bg-slate-300 dark:bg-slate-600 rounded" />
        <div className="h-3 w-20 bg-slate-300 dark:bg-slate-600 rounded" />
      </div>
    ),
    line: (
      <div className="h-4 bg-slate-200 dark:bg-slate-700 rounded animate-pulse" />
    ),
    text: (
      <div className="space-y-2 animate-pulse">
        <div className="h-4 bg-slate-200 dark:bg-slate-700 rounded w-full" />
        <div className="h-4 bg-slate-200 dark:bg-slate-700 rounded w-5/6" />
        <div className="h-4 bg-slate-200 dark:bg-slate-700 rounded w-4/6" />
      </div>
    ),
    stat: (
      <div className="pos-stat-card px-4 py-2.5 min-w-[90px] animate-pulse">
        <div className="h-3 bg-slate-300 dark:bg-slate-600 rounded w-16 mb-2" />
        <div className="h-6 bg-slate-300 dark:bg-slate-600 rounded w-12" />
      </div>
    ),
  };

  return (
    <>
      {skeletons.map((i) => (
        <div key={i} className={className}>
          {variants[variant] || variants.card}
        </div>
      ))}
    </>
  );
};

export default LoadingSkeleton;
